/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import type { TypePolicies } from '@apollo/client';
import { merge } from 'ts-deepmerge';

import type { StrictTypedTypePolicies } from '@fai/friendli-suite/generated/apollo-helpers';

import { scalarTypePolicies as generatedTypePolicies } from './generated/scalar-type-policies';

const manualTypePolicies: StrictTypedTypePolicies = {
  ClientUserTeam: {
    fields: {
      productAccess: {
        merge: true,
      },
    },
  },
  ClientTeam: {
    fields: {
      serverlessSubplan: {
        merge: true,
      },
      containerSubplan: {
        merge: true,
      },
    },
  },
  UserTeamProductAccessInfo: {
    merge: true,
  },
  DedicatedProjectEndpointConnection: {
    merge: true,
  },
  DedicatedProjectModelConnection: {
    merge: true,
  },
  DedicatedFinetuningAdapterConnection: {
    merge: true,
  },
  DedicatedEndpointUsageSeries: {
    merge: true,
  },
  DedicatedEndpointMetricSeries: {
    merge: true,
  },
  DedicatedEndpointLogHistory: {
    merge: true,
  },
  DedicatedEndpointLoraAdapter: {
    keyFields: ['route'],
  },
  ServerlessSubplan: {
    keyFields: ['teamId'],
  },
  ContainerSubplan: {
    keyFields: ['teamId'],
  },
  DedicatedEndpointAdvancedConfig: {
    merge: true,
  },
  /* has wandb and hugginface under */
  ClientUserIntegration: { merge: true },
  DedicatedProjectUsage: {
    keyFields: ['endpointId'],
  },
};

export const typePolicies = merge(manualTypePolicies, generatedTypePolicies) as TypePolicies;
